module.exports = __webpack_public_path__ + "static/media/SentrySafe_Store_logo@2x.eb2b01b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/SentrySafe_Store_logo@2x.png
// module id = 1174
// module chunks = 0